import React from "react";
import { TicketContextProvider } from "@/views/pages/tickets/TicketContext";
import { Box, Typography, useTheme } from "@mui/material";
import TicketSubmitHandler from "./ticket-submit-handler";
/**
 * TicketPage component renders the main page for the GitLab Ticket Generator
 * @returns {React.ReactElement} The React element to be rendered
 */
const TicketPage = (): React.ReactElement => {
  const theme = useTheme();
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          p: "1rem"
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            width: "100%"
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            color="#D42C2C"
          >
            <line x1="6" x2="6" y1="3" y2="15"></line>
            <circle cx="18" cy="6" r="3"></circle>
            <circle cx="6" cy="18" r="3"></circle>
            <path d="M18 9a9 9 0 0 1-9 9"></path>
          </svg>
          <Typography
            variant="h5"
            sx={{
              fontSize: "2rem",
              color: theme.palette.primary.main
            }}
          >
            GitLab Ticket Generator
          </Typography>
        </Box>
        <span>Generate AI-powered tickets and user stories for your GitLab projects</span>
      </Box>

      <TicketContextProvider>
        <TicketSubmitHandler />
      </TicketContextProvider>
    </>
  );
};

export default TicketPage;
